<h2 mat-dialog-title>
  <span data-cy="dialog-title">
    @if (data.icon) {
      <mat-icon>{{ data.icon }}</mat-icon>
    }
    {{ data.title }}
  </span>
</h2>
<mat-dialog-content [innerHTML]="data.message" data-cy="dialog-content"></mat-dialog-content>
<mat-dialog-actions align="end" data-cy="dialog-actions">
  <button
    id="dialog-cancel-button"
    mat-button
    (click)="refresh()"
    [mat-dialog-close]="true"
    data-cy="dialog-actions-cancel">
    {{ data.confirmButtonText }}
  </button>
</mat-dialog-actions>
